var FileManager = (function() {

    var _this;

    _this = {
        storeGamePdf: function(fileBase64, fileName) {
            return new Promise((resolve, reject) => {
                Api.request('/battle/game/pdf', {
                    file: fileBase64,
                    name: fileName
                }).then(result => {
                    if (result && result.url) {
                        resolve(result.url);
                    } else {
                        reject((result && result.error) ? result.error : 'error.unknown');
                    }
                }).catch(reject);
            });
        },

        openWindow: function(url, dialogTitle, dialogContent, dialogButton, dialogButtonIcon, forceDialog) {
            var win;

            if (ScoreTrekBattle.Session.isAppMode()) {
                forceDialog = true;
            }

            win = forceDialog ? null : window.open(url);

            if (!win) {
                chmDialog({
                    title: dialogTitle,
                    content: dialogContent,
                    buttons: [
                        {
                            label: dialogButton,
                            icon: dialogButtonIcon,
                            primary: true,
                            action: function() {
                                window.open(url);
                            }
                        }
                    ]
                });
            }
        }
    };

    return _this;
})();
